<template>
  <div>
    <component :is="currentComponent">

    </component>
  </div>
</template>

<script>
import Pages from '../pages/index';
import Utils from '../../mixins/utils';
export default {
  name: 'manage',
  created() {
    this.loadComponent(this.$route.params.slug);
  },
  mixins: [Utils],
  watch: {
    '$route.params.slug': {
      handler(val, oldVal) {
        console.log('new slug', val);
        this.loadComponent(val);
      }
    }
  },
  data() {
    return {
      currentComponent: Pages['updates'],
      defaultSlugs: [
        'updates',
        'backups',
        'activityLog',
        'pluginsAndThemes',
        'loginActivity'
      ]
    };
  },
  methods: {
    loadComponent(slug) {
      if (this.defaultSlugs.indexOf(slug) > -1) {
        this.currentComponent = Pages[slug];
      }
      // else {
      //   this.currentComponent = () =>
      //     this.loadAddon(slug).then(module => {
      //       // this.$store.registerModule(slug, module.default.Store);
      //       return module.default.Component;
      //     });
      // }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Manage/Manage.vue